import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { filter, Observable, switchMap, take } from 'rxjs';

import { KnBrQuoteReference } from 'src/feature-libs/kn-br-cart/saved-carts/root/models/kn-br-quote.model';
import {
  KN_BR_CUSTOMER_CURRENT,
  KN_BR_GET_QUOTE_REFERENCE,
  KN_BR_GET_QUOTE_REFERENCE_BY_PRODUCT,
  KN_BR_QUOTE_UPDATE_ENTRY,
  KN_BR_REMOVE_QUOTE_REFERENCE,
  KN_BR_UPDATE_QUOTE_REFERENCE,
} from '../../../../../constants/api.endpoints.constant';
import { KnBrCustomerContextService } from '../../../../../store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrCartContextService } from '../../../base/core/facade/kn-br-cart-context.service';
import { KnBrQuotesService } from '../facade/kn-br-quotes.service';
import { KnBrQuoteContextAdapter } from './kn-br-quote-context.adapter';

@Injectable({
  providedIn: 'root',
})
export class KnBrQuoteReferenceAdapter {
  customerId: string;
  cartId: string;
  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected knBrCartContextService: KnBrCartContextService,
    protected quoteContextAdapter: KnBrQuoteContextAdapter,
    public knBrQuoteService: KnBrQuotesService
  ) {
    this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
      this.customerId = response ? response : null;
    });
    this.knBrCartContextService.get$.subscribe((response) => {
      this.cartId = response ? response : null;
    });
  }

  public add(reference: KnBrQuoteReference): Observable<KnBrQuoteReference> {
    const toAdd = JSON.stringify({});

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const url = this.occEndpointsService.buildUrl(KN_BR_UPDATE_QUOTE_REFERENCE, {
      urlParams: {
        customerId: this.customerId,
        cartId: this.cartId,
        entryNumber: reference.entryNumber,
      },
      queryParams: { quoteEntryPK: reference.knbrQuoteReference.quoteEntryPK },
    });

    return this.http.patch<KnBrQuoteReference>(url, toAdd, { headers });
  }

  public update(entry: KnBrQuoteReference): Observable<KnBrQuoteReference> {
    const params = {
      quantity: entry.quantity,
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const url = this.occEndpointsService.buildUrl(KN_BR_QUOTE_UPDATE_ENTRY, {
      urlParams: { customerId: this.customerId, cartId: this.cartId, entryNumber: entry.entryNumber },
      queryParams: { ...params },
    });

    return this.http.patch<KnBrQuoteReference>(url, {}, { headers });
  }

  public remove(entryNumber: string): Observable<KnBrQuoteReference> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const url = this.occEndpointsService.buildUrl(KN_BR_REMOVE_QUOTE_REFERENCE, {
      urlParams: {
        customerId: this.customerId,
        cartId: this.cartId,
        entryNumber,
      },
    });
    return this.http.patch<KnBrQuoteReference>(url, { headers });
  }

  get(entryNumber) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const url = this.occEndpointsService.buildUrl(KN_BR_GET_QUOTE_REFERENCE, {
      urlParams: { customerId: this.customerId, cartId: this.cartId, entryNumber },
    });
    return this.http.get<KnBrQuoteReference>(url, { headers });
  }

  getByProduct(productId) {
    if (this.quoteContextAdapter.get()) {
      return this.knBrQuoteService.get$.pipe(
        filter((quote) => !!quote),
        take(1),
        switchMap((quoteResponse) => {
          if (quoteResponse?.step2customerUnit) {
            return this.getByProductUrl(productId, quoteResponse?.step2customerUnit);
          } else {
            return this.getByProductUrl(productId);
          }
        })
      );
    } else {
      return this.getByProductUrl(productId);
    }
  }

  getByProductUrl(productId: string, step2customerUnit?: string): Observable<KnBrQuoteReference> {
    const CUSTOMER_NUMBER = this.customerId ? this.customerId : KN_BR_CUSTOMER_CURRENT;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const url = this.occEndpointsService.buildUrl(KN_BR_GET_QUOTE_REFERENCE_BY_PRODUCT, {
      urlParams: {
        customerId: CUSTOMER_NUMBER,
        productId,
      },
      queryParams: {
        step2customerUnit,
      },
    });

    return this.http.get<KnBrQuoteReference>(url, { headers });
  }
}
